import * as z from "zod";
import { OC } from "../../utils";
import { AdminTrip } from "./schema";

export const tripContract = OC.router({
  get: OC.meta({ permissions: ["trip:get"] })
    .input(AdminTrip.Get)
    .output(AdminTrip.Trip),
  getAll: OC.meta({ permissions: ["trip:get"] })
    .input(AdminTrip.GetAll)
    .output(z.array(AdminTrip.Trip)),
  create: OC.meta({
    alters: true,
    permissions: ["trip:create"],
    auditLog: { modelName: "TRIP", action: "CREATE" },
    aragon: "trip_created",
  })
    .input(
      AdminTrip.Create.safeExtend({
        images: z.array(
          z
            .instanceof(File)
            .refine(
              (file) =>
                ["image/jpeg", "image/png", "image/webp"].includes(file.type),
              {
                message: "Image must be a JPEG, PNG, or WebP",
              },
            )
            .refine(
              (file) => file.size <= 10 * 1024 ** 2,
              "Image must be less than 10MB",
            ),
        ),
      }),
    )
    .output(
      AdminTrip.Trip.omit({
        status: true,
        currentAmountDue: true,
        currentReservations: true,
        currentRevenue: true,
      }),
    ),
  update: OC.meta({
    alters: true,
    permissions: ["trip:update"],
    auditLog: { modelName: "TRIP", action: "UPDATE" },
    aragon: "trip_updated",
  })
    .input(
      AdminTrip.Update.safeExtend({
        existingImageKeys: z.array(z.string()).optional(),
        newImages: z
          .array(
            z
              .instanceof(File)
              .refine(
                (file) =>
                  ["image/jpeg", "image/png", "image/webp"].includes(file.type),
                {
                  message: "Image must be a JPEG, PNG, or WebP",
                },
              )
              .refine(
                (file) => file.size <= 10 * 1024 ** 2,
                "Image must be less than 10MB",
              ),
          )
          .optional(),
      }),
    )
    .output(
      AdminTrip.Trip.omit({
        status: true,
        currentAmountDue: true,
        currentReservations: true,
        currentRevenue: true,
      }),
    ),
  delete: OC.meta({
    alters: true,
    permissions: ["trip:delete"],
    auditLog: { modelName: "TRIP", action: "DELETE" },
    aragon: "trip_deleted",
  })
    .input(AdminTrip.Delete)
    .output(
      AdminTrip.Trip.omit({
        status: true,
        currentAmountDue: true,
        currentReservations: true,
        currentRevenue: true,
      }),
    ),
  toggleVisibility: OC.meta({
    alters: true,
    permissions: ["trip:update"],
    auditLog: { modelName: "TRIP", action: "UPDATE" },
    aragon: "trip_visibility_toggled",
  })
    .input(AdminTrip.Get.extend({ visible: z.boolean() }))
    .output(
      AdminTrip.Trip.omit({
        status: true,
        currentAmountDue: true,
        currentReservations: true,
        currentRevenue: true,
      }),
    ),
});
